const Paper = ({ children, className, border = false, dataTestId = '' }) => {
  return (
    <div
      className={`paper-container ${className ? className : ''} ${border ? 'with-border' : ''}`}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

export default Paper;
